import React from 'react';
import {NodeProps, Node} from 'reactflow';

import {ProcessFlowchartNodeType} from 'processes/modals/field-mapping/transition-modal-with-flowchart-editor/transitionModalWithFlowchartEditorConstants';
import {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';
import BenchlingNode from 'ui-library/reactflow/nodes/BenchlingNode/BenchlingNode';
import {BenchlingNodeData} from 'ui-library/reactflow/nodes/BenchlingNode/BenchlingNodeTypes';

interface TaskSchemaDomainData {
  id: string;
  nodeType: ProcessFlowchartNodeType;
}

export interface TaskSchemaNodeRowData {
  id: string;
  isFlowchartTask: boolean;
  sectionName: string;
  fieldName: string;
  fieldIcon: BenchlingIconName;
  fieldTypeLabel: string | JSX.Element;
  isSelected?: boolean;
}

type BaseData = BenchlingNodeData<TaskSchemaNodeRowData>;

interface TaskSchemaInteractionNodeData {
  onNodeHeaderClick: (nodeId: string) => void;
  nodeDetailsSidepanelContent: (node: Node) => JSX.Element | null;
  onFieldClick: (nodeId: string, fieldId: string) => void;
  rowRenderer: BaseData['rowRenderer'];
  nodeHeaderHandleRenderer: BaseData['nodeHeaderHandleRenderer'];
}

/**
 * Static data that is used for converting from and persisting task schemas to the database.
 *
 * Removes fields that should not be populated when converting from a task schema to a node.
>>>>>>> origin/dev
 */
export type TaskSchemaStaticNodeData = TaskSchemaDomainData &
  Omit<
    BaseData,
    'rowRenderer' | 'nodeHeaderHandleRenderer' | 'nodeIcon' | 'nodeValidationState' | 'onNodeHeaderClick'
  >;

/**
 * Populated data to be passed to the base node renderer.
 *
 * Adds fields that are specific to flowchart visualization and interaction, that are not needed
 * when converting from a task schema to a node or persisting to the database.
 */
export type TaskSchemaNodeData = TaskSchemaStaticNodeData & TaskSchemaInteractionNodeData;
export type TaskSchemaNode = Node<TaskSchemaNodeData>;

/**
 * Props for the task schema node renderer
 */
export type TaskSchemaNodeRendererProps = NodeProps<TaskSchemaNodeData>;

export default function TaskSchemaNodeRenderer(props: TaskSchemaNodeRendererProps): JSX.Element {
  return <BenchlingNode<TaskSchemaNodeRowData, TaskSchemaNodeData> {...props} />;
}
